import { render } from "./PaymentsForm.vue?vue&type=template&id=6de839fe&scoped=true"
import script from "./PaymentsForm.vue?vue&type=script&lang=js"
export * from "./PaymentsForm.vue?vue&type=script&lang=js"

import "./PaymentsForm.vue?vue&type=style&index=0&id=6de839fe&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6de839fe"]])

export default __exports__